import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import admin from'../../assets/images/users/avatar_admin.png';
import editor from '../../assets/images/users/avatar_editor.png';
import support from '../../assets/images/users/avatar_support.png';
import {logoutUser} from "../../store/auth/login/actions";
import {useNavigate} from "react-router-dom";

const ProfileDropdown = () => {
    const { user } = useSelector(state => ({
        user: state.Login.user,
    }));

    const [userName, setUserName] = useState("User");
    const [role, setRole] = useState("admin");

    useEffect(() => {
        if (user && user.firstname) {
            setUserName(user.firstname);
        } else {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                try {
                    const parsed = JSON.parse(storedUser);
                    setUserName(parsed.firstname || parsed.name || "User");
                } catch (e) {
                    console.error("Failed to parse user:", e);
                }
            }
        }
        if (user && user.role) {
            setRole(user.role);
        } else {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                try {
                    const parsed = JSON.parse(storedUser);
                    setRole(parsed.role || "user");
                } catch (e) {
                    console.error("Failed to parse user:", e);
                }
            }
        }
    }, [user]);
    const getAvatarByRole = (role) => {
        switch(role?.toLowerCase()) {
            case 'admin':
                return admin;
            case 'support':
                return support;
            case 'editor':
                return editor;

        }
    };

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };


    // Add dispatch for logout
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const handleLogout = () => {
        dispatch(logoutUser({navigate}));
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
          <span className="d-flex align-items-center">
            <img  src={getAvatarByRole(role)} className="rounded-circle header-profile-user"
                 alt="Header Avatar" />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{role}</span>
            </span>
          </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-profile-settings"}><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">Profile</span></DropdownItem>
                    <DropdownItem onClick={handleLogout}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                        className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;